import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject;
import styled from 'styled-components';
import { getBackgroundColor } from '@magalu/stereo-ui-styles';
export var Container = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  background-color: ", ";\n"])), function (props) {
  return getBackgroundColor('lighter')(props);
});